import { render, staticRenderFns } from "./InvitationStatus.vue?vue&type=template&id=3cdb252e&scoped=true"
import script from "./InvitationStatus.vue?vue&type=script&lang=js"
export * from "./InvitationStatus.vue?vue&type=script&lang=js"
import style0 from "./InvitationStatus.vue?vue&type=style&index=0&id=3cdb252e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdb252e",
  null
  
)

export default component.exports